import { useEffect, useState } from "react";
import {
  IAPIResponse,
  IUserProfile,
} from "../../../../../common/utils/interfaces";
import { getMyProfile } from "../../../../../../apis/accounts/user";
import BuyerDashboardLayout from "../../components/DashboardLayout";
import { TextField, Typography } from "@mui/material";

const Profile: React.FC = () => {
  const [userInfo, setUserInfo] = useState<IUserProfile | null>(null);

  useEffect(() => {
    const initPage = async () => {
      loadAllInfo();
    };

    initPage();
  }, []);

  const loadAllInfo = async () => {
    const response: IAPIResponse | undefined = await getMyProfile();

    if (response?.status) {
      setUserInfo(response.data);
      localStorage.setItem("userInfo", JSON.stringify(response.data));
    }
  };

  const AccountStatus = () => (
    <div className={`profile-badge _${userInfo?.status}`}>{`${
      userInfo?.status === "pending"
        ? "PENDING APPROVAL"
        : `${userInfo?.status?.toUpperCase() || ""} ACCOUNT`
    }`}</div>
  );

  return (
    <BuyerDashboardLayout>
      <div className="page-body profile-page width-700">
        <div className="profile-header _pc">
          <Typography variant="h3">My Profile</Typography>
          <AccountStatus />
        </div>
        <div
          style={{
            borderBottom: "solid 1px #ddd",
            padding: "10px 0",
            margin: "15px 0",
          }}
        >
          <Typography variant="h4">Personal Details</Typography>{" "}
          <div className="_mobile">
            <AccountStatus />
          </div>
        </div>

        <div className="form-form">
          <div className="form-row">
            <div className="form-input">
              <Typography>Name</Typography>
              <TextField
                value={`${userInfo?.first_name || "-"} ${
                  userInfo?.last_name || "-"
                }`}
                // onChange={updateFormData}
                fullWidth
                disabled
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-input">
              <Typography>Phone number</Typography>
              <TextField
                value={userInfo?.phone_number}
                // onChange={updateFormData}
                fullWidth
                disabled
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-input">
              <Typography>Email</Typography>
              <TextField
                value={userInfo?.email}
                // onChange={updateFormData}
                fullWidth
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </BuyerDashboardLayout>
  );
};

export default Profile;
